import { join, sep } from 'node:path';
import { existsSync } from 'node:fs';

import env from '#shared/config/env.js';
import getTransformedCountryList from '#shared/util/getTransformedCountryList.js';
import sortCountriesByLabel from '#shared/util/sortCountriesByLabel.js';

import { readJSONWithMemo } from '#backend/util/readJSON.js';

/**
 * Country schema
 * @param {object} data
 * @param {string} data.locale Locale
 * @param {object[]} data.countries List of all authorized countries for specific locale
 * @returns {object[]}
 */
export const countrySchema = ({ locale, countries }) => {
	// Load a correct localization file
	let countriesLocalization;
	const defaultPath = join(env.paths.themesPath, 'default/default/localization');
	try {
		const [language, region] = locale.toLowerCase().split(/[-_]/); // en-us => en-us => [en, us]
		const regionPath = [defaultPath, language, region].join(sep); // Path => localization/en/us
		const languagePath = [defaultPath, language].join(sep); // Path => localization/en
		// Check if region path exists else use language based files
		if (existsSync(regionPath)) {
			countriesLocalization = readJSONWithMemo(`${regionPath}/countries.json`);
		} else if (existsSync(languagePath)) {
			countriesLocalization = readJSONWithMemo(`${languagePath}/countries.json`);
		} else {
			countriesLocalization = readJSONWithMemo(`${defaultPath}/countries.json`);
		}
	} catch {
		// Don't do anything, handled later in code - provider translation would be used
	}
	// Transform country list to a correct format for the country selector
	const transformedCountryList = getTransformedCountryList(countries, countriesLocalization);
	// Return sorted country list by its label (display name) based on language
	return sortCountriesByLabel(transformedCountryList, locale);
};
